import { p as proxyCustomElement, H, h } from './p-DWmaQhSz.js';

/*!
 * Planning Center Tapestry Web Components
 * Version: 1.3.0
 */

const PageHeader = /*@__PURE__*/ proxyCustomElement(class PageHeader extends H {
    constructor() {
        super();
        this.__registerHost();
        /**
         * Indicates whether the page header is inactive or not.
         * When set to true, the page header is visually inactive
         * @prop {boolean} inactive - Controls the inactive state of the page. Defaults to false.
         */
        this.inactive = false;
    }
    // --------------------------------------------------------------------------
    //
    //  Render Methods
    //
    // --------------------------------------------------------------------------
    render() {
        var _a, _b;
        const hasNavigationSlot = !!this.el.querySelector("[slot='navigation']");
        const hasMultiActions = ((_b = (_a = this.el.querySelector("[slot='actions']")) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.length) > 1;
        return (h("header", { key: '5bc242fa9b6bee48b26c9a4923129341da78a67f', class: {
                "tds-page-header": true,
                "has-multi-actions": hasMultiActions,
                "has-nav": hasNavigationSlot,
                "tds-page-header--profile": this.profile,
                inactive: this.inactive,
            } }, h("div", { key: '3ed8678f6f67e6f003fa2fa052e442dadad66f6e', class: "tds-page-header__title-bar" }, h("div", { key: 'c60c887286d4b3c2f58084c01e543755cd05c041', class: "tds-page-header__primary" }, h("slot", { key: 'f14197bcbaed9b4d0efd62c3f57e9f4155be6c52' })), h("slot", { key: 'ef5b3fb54b5db23cf54dd005a11be726c0c1fe9c', name: "actions" })), hasNavigationSlot && (h("tds-page-header-nav", { key: 'c831d2524bf009c1891069fc51b6f3044c52a81d' }, h("slot", { key: 'a5e4ab6caa49352c9f27288f74a4e5c64089c720', name: "navigation" })))));
    }
    get el() { return this; }
}, [4, "tds-page-header", {
        "inactive": [4],
        "profile": [4]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["tds-page-header"];
    components.forEach(tagName => { switch (tagName) {
        case "tds-page-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PageHeader);
            }
            break;
    } });
}
const defineCustomElement = defineCustomElement$1;

export { defineCustomElement };
//# sourceMappingURL=tds-page-header.js.map
